import { h, ComponentChildren } from 'preact'
import Icon, { IconType } from '../../assets/'
import { clickableLink } from './HitContainerWithFederated'

interface Props {
  icon: IconType
  children: ComponentChildren
  href: string
  highlightedIndex: number
  previousResultsCount: number
  getItemProps: clickableLink
}

const SearchActionLink = ({ highlightedIndex, previousResultsCount, href, icon, children, getItemProps }: Props) => (
  <a
    className='link algolia-search__action'
    style={{ backgroundColor: highlightedIndex === previousResultsCount ? '#F2F2F2' : '' }}
    href={href}
    {...getItemProps({ item: { url: href }, index: previousResultsCount })}
  >
    <Icon color='currentColor' customClass='algolia-search__action-icon' icon={icon} height={20} width={20} />
    <span class='algolia-search__action-link'>
      {children}
    </span>
  </a>)

export default SearchActionLink
